/*
 * loywis-icons.js — inline SVG icons for dynamic (JS-rendered) UI.
 * Mirrors snippets/loywis-icon.liquid for the subset used in scripts.
 * Usage:  el.innerHTML = LWIcon('cart');   btn.innerHTML = LWIcon('heart-outline', 20);
 *         LWIcon.monogram('Priya S.')  -> initials for review avatars.
 */
(function (w) {
  var P = {
    'check': '<polyline points="20 6 9 17 4 12"/>',
    'check-circle': '<circle cx="12" cy="12" r="9"/><polyline points="16 9.5 10.5 15 8 12.5"/>',
    'x': '<line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/>',
    'close': '<line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/>',
    'alert': '<path d="M12 3 2.5 20h19L12 3z"/><line x1="12" y1="10" x2="12" y2="14"/><line x1="12" y1="17.5" x2="12" y2="17.5"/>',
    'hourglass': '<path d="M6 3h12M6 21h12M7 3c0 5 5 6 5 9s-5 4-5 9M17 3c0 5-5 6-5 9s5 4 5 9"/>',
    'cart': '<circle cx="9.5" cy="20" r="1.3"/><circle cx="17.5" cy="20" r="1.3"/><path d="M2.5 3.5h2.2l2.3 12.2a1.6 1.6 0 0 0 1.6 1.3h8.4a1.6 1.6 0 0 0 1.6-1.3l1.4-7.4H6"/>',
    'bag': '<path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
    'share': '<circle cx="6" cy="12" r="2.4"/><circle cx="17" cy="6" r="2.4"/><circle cx="17" cy="18" r="2.4"/><line x1="8.1" y1="10.9" x2="14.9" y2="7.1"/><line x1="8.1" y1="13.1" x2="14.9" y2="16.9"/>',
    'settings': '<line x1="4" y1="8" x2="20" y2="8"/><circle cx="9" cy="8" r="2.2"/><line x1="4" y1="16" x2="20" y2="16"/><circle cx="15" cy="16" r="2.2"/>',
    'eye': '<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/>',
    'search': '<circle cx="10.5" cy="10.5" r="6.5"/><line x1="15.5" y1="15.5" x2="21" y2="21"/>',
    'bolt': '<path d="M13 2 4 14h6l-1 8 9-12h-6l1-8z"/>',
    'refresh': '<path d="M20 8a8 8 0 0 0-14-2M4 6v4h4"/><path d="M4 16a8 8 0 0 0 14 2M20 18v-4h-4"/>',
    'gem': '<path d="M6 4h12l3 5-9 11L3 9z"/><path d="M3 9h18M9 4 7.5 9 12 20 16.5 9 15 4M9 9h6"/>',
    'star': '<path d="M12 3l2.6 5.6 6 .7-4.5 4.2 1.2 6L12 16.7 6.7 19.5l1.2-6L3.4 9.3l6-.7z" fill="currentColor" stroke="none"/>',
    'heart': '<path d="M12 20.5S3.5 15 3.5 8.8A4.3 4.3 0 0 1 12 6.6a4.3 4.3 0 0 1 8.5 2.2C20.5 15 12 20.5 12 20.5z" fill="currentColor" stroke="none"/>',
    'heart-outline': '<path d="M12 20.5S3.5 15 3.5 8.8A4.3 4.3 0 0 1 12 6.6a4.3 4.3 0 0 1 8.5 2.2C20.5 15 12 20.5 12 20.5z"/>'
  };

  function LWIcon(name, size) {
    var sz = size || 18;
    var inner = P[name] || '<circle cx="12" cy="12" r="3" fill="currentColor" stroke="none"/>';
    return '<svg class="lw-ic lw-ic--' + name + '" width="' + sz + '" height="' + sz +
      '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      inner + '</svg>';
  }

  // Initials monogram for review avatars (replaces person emojis).
  LWIcon.monogram = function (nameStr) {
    var s = (nameStr || '').trim();
    if (!s) return '?';
    var parts = s.split(/\s+/);
    var a = parts[0] ? parts[0].charAt(0) : '';
    var b = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
    return (a + b).toUpperCase();
  };

  w.LWIcon = LWIcon;
})(window);
